import { createSelector } from 'reselect';
import type { State } from '../types.tsx';

export const getShouldSeeOnboarding = (state: State) => state.shouldSeeOnboarding;

export const shouldUserSeeVideoAndCommunityFlag = createSelector(
	getShouldSeeOnboarding,
	(shouldSeeOnboarding) => shouldSeeOnboarding === true,
);
